import { Badge, badgeClasses, IconButton, styled } from '@mui/material';
import classNames from 'classnames';
import { MY, NOTIFICATIONS } from 'config/fe-routes';
import IosMail from 'react-ionicons/lib/IosMail';
import IosNotifications from 'react-ionicons/lib/IosNotifications';
import { connect } from 'react-redux';
import { redirectTo } from 'utils/route-helpers';

import HeaderItem from '../HeaderItem';

const NotificationBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: -6px;
  }
`;

type Props = {
  messagesCount: number;
  notificationsCount: number;
};

const mapStateToProps = ({ messagesCountData }) => ({
  messagesCount: messagesCountData.messages,
  notificationsCount: messagesCountData.notifications,
});

const HeaderNotifications = (props: Props) => {
  const { messagesCount, notificationsCount } = props;

  const onClickMessages = () => {
    redirectTo({ ...MY.MESSAGES() });
  };

  const onClickNotifications = () => {
    redirectTo({ ...NOTIFICATIONS() });
  };

  return (
    <HeaderItem>
      {/* Messages */}
      <IconButton
        onClick={onClickMessages}
        className={classNames('notification-icon', {
          unread: messagesCount > 0,
        })}
      >
        <IosMail className="messages-icon" />

        <NotificationBadge badgeContent={messagesCount} overlap="circular" color="primary" />
      </IconButton>

      {/* Notifications */}
      <IconButton
        onClick={onClickNotifications}
        className={classNames('notification-icon', {
          unread: notificationsCount > 0,
        })}
        sx={{ marginLeft: '6px' }}
      >
        <IosNotifications className="notifications-icon" />

        <NotificationBadge badgeContent={notificationsCount} overlap="circular" color="primary" />
      </IconButton>
    </HeaderItem>
  );
};

export default connect(mapStateToProps)(HeaderNotifications);
